import type { LogEntry, LogTransport } from '../types'
import { LogLevel } from '../types'

/**
 * Console transport - outputs logs to browser console
 * Used primarily in local and dev environments
 */
export class ConsoleTransport implements LogTransport {
  private minLevel: LogLevel

  constructor(minLevel: LogLevel = LogLevel.DEBUG) {
    this.minLevel = minLevel
  }

  shouldLog(level: LogLevel): boolean {
    return level >= this.minLevel
  }

  log(entry: LogEntry): void {
    if (!this.shouldLog(entry.level)) {
      return
    }

    const { level, message, timestamp, context, error } = entry

    // Format the log message
    const prefix = `[${timestamp}] [${LogLevel[level]}]`
    const contextStr = context ? JSON.stringify(context, null, 2) : ''

    // Choose appropriate console method based on log level
    switch (level) {
      case LogLevel.DEBUG:
        console.debug(prefix, message, contextStr)
        break
      case LogLevel.INFO:
        console.info(prefix, message, contextStr)
        break
      case LogLevel.WARN:
        console.warn(prefix, message, contextStr)
        break
      case LogLevel.ERROR:
      case LogLevel.CRITICAL:
        console.error(prefix, message, contextStr)
        if (error) {
          console.error('Error details:', error)
        }
        break
    }
  }
}
